var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('Nav'),_c('div',{attrs:{"id":"h"}},[_c('Heade'),_c('Banner'),_c('Content'),_c('Fotter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }